<template>
  <div>
    <modal
      ref="printerCalibrationModal"
      template="question"
      title="Calibrar impressora"
      ref-name="printerCalibrationModal"
      first-button-text="Não"
      :icon-enabled="false"
      second-button-text="Sim"
      :close-button-enabled="true"
      class="printer-calibration-modal"
      @first-cta="close()"
      @second-cta="calibrate(printerModel)"
    >
      <p>Selecione o modelo da sua impressora:</p>
      <md-radio
        v-model="printerModel"
        :md-value="FIRST_PRINTER_MODEL.value"
      >
        {{ FIRST_PRINTER_MODEL.label }}
      </md-radio>
      <md-radio
        v-model="printerModel"
        :md-value="SECOND_PRINTER_MODEL.value"
      >
        {{ SECOND_PRINTER_MODEL.label }}
      </md-radio>

      <div class="information-container">
        <md-tooltip md-direction="top">
          Clique aqui para localizar modelo da impressora
        </md-tooltip>
        <md-icon @click.native="switchToInfoModal()">
          info
        </md-icon>
      </div>

      <p>O AOL irá calibrar sua impressora (ela ficará inacessível por alguns instantes).</p>

      <p class="bold">
        Deseja prosseguir?
      </p>
    </modal>

    <modal
      ref="printerCalibrationModalInfo"
      template="neutral"
      icon-type="back"
      :icon-enabled="true"
      :header-clickable="true"
      ref-name="printerCalibrationModalInfo"
      title="Localizar modelo da impressora"
      @header-action="switchToPrinterModal()"
    >
      <printer-calibration-information />
    </modal>
  </div>
</template>

<script>
import PrinterCalibrationInformation from './PrinterCalibrationInformation'

const FIRST_PRINTER_MODEL = {value: 'TLP2844', label: 'ZEBRA - TLP2844'}
const SECOND_PRINTER_MODEL = {value: 'GC420', label: 'ZEBRA - GC420/ZD220'}

export default {
  name: 'PrinterCalibratrionModal',
  components: {
    'printer-calibration-information': PrinterCalibrationInformation
  },
  props: {
    close: Function,
    calibrate: Function
  },
  data: () => {
    return {
      printerModel: FIRST_PRINTER_MODEL.value,
      FIRST_PRINTER_MODEL: FIRST_PRINTER_MODEL,
      SECOND_PRINTER_MODEL: SECOND_PRINTER_MODEL
    }
  },
  methods: {
    openInformationModal () {
      this.$refs.printerCalibrationModalInfo.open()
    },
    closeInformationModal () {
      this.$refs.printerCalibrationModalInfo.close()
    },
    openPrinterCalibrationModal () {
      this.$refs.printerCalibrationModal.open()
      this.$analytics.pushAnalyticsEvent('vpageview', {
        'page': '/modal/print-calibration',
        'id-usuario': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'nlab': this.profile.laboratoryName
      })
    },
    closePrinterCalibrationModal () {
      this.$refs.printerCalibrationModal.close()
    },
    switchToInfoModal () {
      this.closePrinterCalibrationModal()
      this.openInformationModal()
      this.$analytics.pushAnalyticsEvent('ga-event', {
        'category': 'Calibrar Impressora',
        'action': 'Instruções para localizar modelo da impressora'
      })
    },
    switchToPrinterModal () {
      this.closeInformationModal()
      this.openPrinterCalibrationModal()
    }
  }
}
</script>

<style lang="scss">
.printer-calibration-modal .md-dialog {
  max-width: 700px;

  .information-container {
    display: inline-grid;
    cursor: pointer;

    i {
      color: #aaa;
      font-size: 1.3em;

      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        /* IE10 & IE11 CSS styles go here */
        padding-top: 7px;
        margin-left: -4px;
      }
    }
  }

  .md-radio {
    margin-right: 20px;
  }
}
</style>
